var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.111 20c.37 0 .685-.142 1.056-.346l10.796-5.971c.768-.434 1.037-.718 1.037-1.187 0-.47-.268-.754-1.037-1.179L8.167 5.337C7.797 5.133 7.48 5 7.11 5 6.426 5 6 5.496 6 6.267v12.457C6 19.495 6.426 20 7.111 20Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPlay);
export default Memo;